import { Component, Inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  EditarRegistroHorasDTO,
  RegistroDetalleTiempo,
} from '../../../../../models/personal/registro-horas.model';
import { RegistroHorasService } from '../../../../../services/employees/registro-horas.service';

export interface EditarRegistroModalData {
  registro: RegistroDetalleTiempo;
}

/**
 * Diálogo para editar un fichaje ya creado. El motivo es obligatorio: el backend deja
 * constancia del estado anterior en el histórico de auditoría antes de aplicar el cambio.
 */
@Component({
  selector: 'app-editar-registro-modal',
  templateUrl: './editar-registro-modal.component.html',
  standalone: false,
})
export class EditarRegistroModalComponent {
  form: UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<EditarRegistroModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditarRegistroModalData,
    private registroHorasService: RegistroHorasService
  ) {
    this.form = new UntypedFormGroup({
      horaEntrada: new UntypedFormControl(this.aHoraInput(data.registro.horaEntrada)),
      horaSalida: new UntypedFormControl(this.aHoraInput(data.registro.horaSalida)),
      comentario: new UntypedFormControl(data.registro.comentario || ''),
      motivo: new UntypedFormControl('', [Validators.required]),
    });
  }

  cancelar(): void {
    this.dialogRef.close(null);
  }

  guardar(): void {
    if (!this.form.valid) {
      return;
    }

    const dto: EditarRegistroHorasDTO = {
      horaEntrada: this.combinarFechaHora(this.data.registro.fecha, this.form.get('horaEntrada').value),
      horaSalida: this.combinarFechaHora(this.data.registro.fecha, this.form.get('horaSalida').value),
      comentario: this.form.get('comentario').value,
      motivo: this.form.get('motivo').value,
    };

    this.registroHorasService
      .editarRegistro(this.data.registro.registroHorasId, dto)
      .subscribe({
        next: (resultado) => this.dialogRef.close(resultado),
      });
  }

  private aHoraInput(valor: string | null): string {
    if (!valor) {
      return '';
    }

    const fecha = new Date(valor);
    if (isNaN(fecha.getTime())) {
      return '';
    }

    return `${fecha.getHours().toString().padStart(2, '0')}:${fecha
      .getMinutes()
      .toString()
      .padStart(2, '0')}`;
  }

  private combinarFechaHora(fecha: string, hora: string): string | null {
    if (!hora) {
      return null;
    }

    const base = new Date(fecha);
    const [horas, minutos] = hora.split(':').map(Number);
    base.setHours(horas, minutos, 0, 0);
    return base.toISOString();
  }
}
